export default __webpack_public_path__ + "static/selectedIcon-c11b609042b6cfda2b4b89db1d95da21.svg";